import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import {
  BenefitSplitLimits,
  ForemanPromocode,
  GeneratePromocodeParams,
  OCC_ENDPOINTS,
  PromoPagination,
  PromoPaginationParams,
} from '@my-account/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ForemanPromocodesApiService {
  private readonly http = inject(HttpClient);
  private readonly occEndpointsService = inject(OccEndpointsService);

  loadBenefitSplitLimits(): Observable<BenefitSplitLimits> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.benefitSplitLimits);

    return this.http.get<BenefitSplitLimits>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.benefitSplitLimits),
    });
  }

  generatePromocode(params: GeneratePromocodeParams): Observable<ForemanPromocode> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.promocodes);

    return this.http.post<ForemanPromocode>(url, params, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.promocodes),
    });
  }

  loadPromocodes(params: PromoPaginationParams): Observable<PromoPagination<ForemanPromocode>> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.promocodes, { queryParams: params });

    return this.http.get<PromoPagination<ForemanPromocode>>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.promocodes),
    });
  }
}
